
import Vue from 'vue';

import SubmitButton from '@/components/controls/submit-button.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';

export default Vue.extend({
  name: 'BannerStandOrdersFilter',
  components: {
    SubmitButton,
    Dropdown,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dropdownItems(): DropdownItems {
      return {
        reset: {
          label: this.$t('Reset Filters'),
          icon: 'close',
        },
      };
    },
  },
  data() {
    return {
      search: '',
    };
  },
  methods: {
    initFilters(): void {
      this.search = this.$router.currentRoute.query.search as string || '';
    },
    applyFilters(): void {
      const { sort, direction, ...queryParams } = this.$route.query;

      this.$router.push({
        params: {
          page: '1',
        },
        query: {
          ...queryParams,
          search: this.search || undefined,
        },
      });
    },
    handleDropdownClick(action: string): void {
      if ('reset' === action) {
        this.$router.push({
          params: {
            page: '1',
          },
          query: {},
        });
      }
    },
  },
  created(): void {
    this.initFilters();
  },
  watch: {
    $route(): void {
      this.initFilters();
    },
  },
});
